import React from 'react';
import { TrendingDown, TrendingUp, Minus } from 'lucide-react';
import type { PriceTrend } from '@/data/marketData';

interface PriceBadgeProps {
  trend: PriceTrend;
  change: number;
  changePct: number;
  size?: 'sm' | 'md';
}

export default function PriceBadge({ trend, change, changePct, size = 'sm' }: PriceBadgeProps) {
  if (trend === 'drop') {
    return (
      <span className={`inline-flex items-center gap-1 font-semibold rounded-full ${size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1'} text-drop-green bg-green-light`}>
        <TrendingDown size={size === 'sm' ? 11 : 14} />
        {Math.abs(changePct).toFixed(1)}%
      </span>
    );
  }
  if (trend === 'rise') {
    return (
      <span className={`inline-flex items-center gap-1 font-semibold rounded-full ${size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1'} text-rise-red bg-red-light`}>
        <TrendingUp size={size === 'sm' ? 11 : 14} />
        +{changePct.toFixed(1)}%
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 font-semibold rounded-full ${size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1'} text-muted-foreground bg-muted`}>
      <Minus size={size === 'sm' ? 11 : 14} />
      Stable
    </span>
  );
}